import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { format } from "date-fns";

export const generateTIReport = (ticket) => {
  console.log("TICKET EN GENERATETIREPORT:", ticket);
  const doc = new jsPDF('p', 'pt', 'a4');

  const colors = {
    blueDark: [15, 36, 76],
    red: [227, 24, 24],
    border: [0, 0, 0]
  };

  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  
  // Título
  doc.text('INCOLAB SERVICES COLOMBIA S.A.S.', 130, 30);

  // Tabla cabecera
  doc.autoTable({
    startY: 35,
    head: [],
    body: [
      ['ACCIÓN DE MANTENIMIENTO EQUIPOS DE CÓMPUTO', 'Cód:FO-GTI-06/V2\nFecha: 2024-07-01']
    ],
    theme: 'grid',
    styles: { 
      halign: 'center', 
      valign: 'middle', 
      fontSize: 9,
      textColor: [0, 0, 0],
      lineColor: colors.border,
      lineWidth: 1
    },
    columnStyles: {
      0: { cellWidth: 350 },
      1: { cellWidth: 150 }
    },
    margin: { left: 40, right: 40, top: 20, bottom: 20 }
  });

  // Extract date and assignations
  const asignacion = ticket.fullHistorial?.find(r => r.EstadoId === 2);
  const resolucionLog = ticket.fullHistorial?.find(r => r.EstadoId === 4);
  const resolucion = resolucionLog?.resolucion || {};
  const fechaInicio = asignacion ? new Date(asignacion.fecha) : (ticket.fechaCreacion ? new Date(ticket.fechaCreacion) : new Date());
  
  // Equipments check
  const tipoEq = ticket.Ticket?.Asignacionequipo?.Equipo?.Tipodeequipo?.descripcion || '';
  const isServidor = tipoEq.toUpperCase().includes('SERVIDOR');
  const isPortatil = tipoEq.toUpperCase().includes('PORTÁTIL') || tipoEq.toUpperCase().includes('PORTATIL');
  const isDesktop = tipoEq.toUpperCase().includes('DESKTOP') || tipoEq.toUpperCase().includes('ESCRITORIO');
  const isMonitor = tipoEq.toUpperCase().includes('MONITOR');

  const marca = ticket.Ticket?.Asignacionequipo?.Equipo?.Marca?.marca || 'N/A';
  const modelo = ticket.Ticket?.Asignacionequipo?.Equipo?.modelo || 'N/A';
  const placa = ticket.cod || ticket.Ticket?.Asignacionequipo?.Equipo?.cod || 'N/A';
  const sistOpe = ticket.Ticket?.Asignacionequipo?.Equipo?.Sistemao?.descripcionso || 'N/A';

  doc.autoTable({
    startY: doc.lastAutoTable.finalY + 10,
    head: [[
      { content: 'Nº TICKET', styles: { fontStyle: 'bold' } },
      { content: 'FECHA Y HORA DE INICIO', styles: { fontStyle: 'bold' } },
      { content: 'NOMBRE:', styles: { fontStyle: 'bold' } },
      { content: 'CARGO O ÁREA', styles: { fontStyle: 'bold' } }
    ]],
    body: [
      [
        `${ticket.TicketId || ticket.id}`,
        format(fechaInicio, "yyyy-MM-dd hh:mm a"),
        ticket.nombre || '',
        ticket.cargoUsuario || ''
      ],
      [
        { content: 'TIPO DE ACCIÓN', styles: { fontStyle: 'bold' } },
        { content: 'MTTO. PREVENTIVO [ ]          MTTO. CORRECTIVO [ X ]', colSpan: 2 },
        { content: 'ASIGNACIÓN [ ]' }
      ],
      [
        { content: 'EQUIPOS', styles: { fontStyle: 'bold' } },
        { content: `SERVIDOR [ ${isServidor ? 'X' : ' '} ]      PORTATIL [ ${isPortatil ? 'X' : ' '} ]`, colSpan: 2 },
        { content: `DESKTOP [ ${isDesktop ? 'X' : ' '} ]      MONITOR [ ${isMonitor ? 'X' : ' '} ]` }
      ],
      [
        { content: `MARCA EQ.       ${!isMonitor ? marca : ''}`, colSpan: 2 },
        { content: `MODELO          ${!isMonitor ? modelo : ''}`, colSpan: 1 },
        { content: `PLACA ACTIVO    ${!isMonitor ? placa : ''}`, colSpan: 1 }
      ],
      [
        { content: `MARCA MON       ${isMonitor ? marca : ''}`, colSpan: 2 },
        { content: `MODELO          ${isMonitor ? modelo : ''}`, colSpan: 1 },
        { content: `PLACA ACTIVO    ${isMonitor ? placa : ''}`, colSpan: 1 }
      ],
      [
        { content: `SISTEMA OPERATIVO    ${sistOpe}`, colSpan: 4 }
      ]
    ],
    theme: 'grid',
    styles: { 
      fontSize: 8,
      lineColor: colors.border,
      lineWidth: 1,
      textColor: [0, 0, 0]
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0]
    },
    margin: { left: 40, right: 40, top: 20, bottom: 20 }
  });

  // Actividades Realizadas / Cambio de Piezas
  const colActividades = [
    `Limpieza Interna [ ${resolucion.limpinter ? 'X' : ' '} ]`,
    `Revisión del sistema de archivos [ ${resolucion.revisisarchi ? 'X' : ' '} ]`,
    `Revisión y limpieza de virus [ ${resolucion.revilimvirus ? 'X' : ' '} ]`,
    `Limpieza de temporales - Depuración de Software [ ${resolucion.limptemp ? 'X' : ' '} ]`,
    `Particionamiento y formateo de disco duro [ ${resolucion.partformat ? 'X' : ' '} ]`,
    `Instalación de sistema operativo [ ${resolucion.instalso ? 'X' : ' '} ]`,
    `Instalación de controladores [ ${resolucion.instacontrola ? 'X' : ' '} ]`,
    `Instalación de actualizaciones sistema operativo [ ${resolucion.instalactso ? 'X' : ' '} ]`,
    `Instalación de actualizaciones - Software Utilitario [ ${resolucion.instasoftutili ? 'X' : ' '} ]`,
    `Configuración en red del dispositivo o equipo [ ${resolucion.confred ? 'X' : ' '} ]`,
    `Configuración de correo electrónico [ ${resolucion.confcorreo ? 'X' : ' '} ]`,
    `Configuración de impresoras - local y red [ ${resolucion.confimpres ? 'X' : ' '} ]`
  ];

  const colPiezas1 = [
    `Disco Duro - Mecánico [ ${resolucion.discosata ? 'X' : ' '} ]`,
    `Disco Duro - Sólido [ ${resolucion.disssd ? 'X' : ' '} ]`,
    `Memoria RAM [ ${resolucion.memoriaram ? 'X' : ' '} ]`,
    `Batería [ ${resolucion.bateria ? 'X' : ' '} ]`,
    `Cargador [ ${resolucion.cargador ? 'X' : ' '} ]`,
    `Tarjeta Madre [ ${resolucion.tarjemadre ? 'X' : ' '} ]`,
    `Procesador [ ${resolucion.procesador ? 'X' : ' '} ]`,
    `Tarjeta de Video [ ${resolucion.tarjevideo ? 'X' : ' '} ]`,
    `Tarjeta de red LAN [ ${resolucion.tarjeredlam ? 'X' : ' '} ]`,
    `Tarjeta de Red Wlan [ ${resolucion.tarjeredwlan ? 'X' : ' '} ]`,
    `Pantalla [ ${resolucion.pantalla ? 'X' : ' '} ]`,
    `Tarjeta Multi I/O [   ]`
  ];

  const colPiezas2 = [
    `Fuente de Poder [ ${resolucion.fuentepod ? 'X' : ' '} ]`,
    `Batería Interna 3V [ ${resolucion.bateinterna ? 'X' : ' '} ]`,
    `Teclado [ ${resolucion.teclado ? 'X' : ' '} ]`,
    `Mouse [ ${resolucion.mouse ? 'X' : ' '} ]`,
    `Combo Inalámbrico [ ${resolucion.combinalamb ? 'X' : ' '} ]`,
    `Diadema [ ${resolucion.diadema ? 'X' : ' '} ]`,
    `Adaptador RJ45 - USB [ ${resolucion.adaptarj45 ? 'X' : ' '} ]`,
    `Multipuerto USB [ ${resolucion.multiusb ? 'X' : ' '} ]`,
    `Funda Para Portátil [ ${resolucion.fundaporta ? 'X' : ' '} ]`,
    `Pad Mouse [ ${resolucion.padmouse ? 'X' : ' '} ]`,
    `Base Refrigerante [   ]`,
    `Cable HDMI [   ]`
  ];

  const activitiesBody = [];
  for (let i = 0; i < 12; i++) {
    activitiesBody.push([
      colActividades[i], colPiezas1[i], colPiezas2[i]
    ]);
  }

  const observacionInicial = ticket.observacionOriginal || ticket.Ticket?.Observacion || 'Sin observación inicial';

  // Descripción de la Falla
  doc.autoTable({
    startY: doc.lastAutoTable.finalY,
    head: [[
      { content: 'DESCRIPCIÓN DE LA FALLA', styles: { fontStyle: 'bold' } }
    ]],
    body: [
      [{ content: observacionInicial, styles: { minCellHeight: 0 } }]
    ],
    theme: 'grid',
    styles: { 
      fontSize: 8,
      lineColor: colors.border,
      lineWidth: 1,
      textColor: [0, 0, 0]
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0]
    },
    margin: { left: 40, right: 40, top: 20, bottom: 20 }
  });

  doc.autoTable({
    startY: doc.lastAutoTable.finalY,
    head: [[
      { content: 'ACTIVIDADES REALIZADAS', styles: { fontStyle: 'bold' } },
      { content: 'CAMBIO DE PIEZAS', colSpan: 2, styles: { fontStyle: 'bold' } }
    ]],
    body: activitiesBody,
    theme: 'grid',
    styles: { 
      fontSize: 8,
      lineColor: colors.border,
      lineWidth: 1,
      textColor: [0, 0, 0]
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0]
    },
    margin: { left: 40, right: 40, top: 20, bottom: 20 }
  });

  // Aplicaciones
  doc.autoTable({
    startY: doc.lastAutoTable.finalY,
    head: [[
      { content: 'Aplicación', styles: { fontStyle: 'bold' } },
      { content: 'Versión', styles: { fontStyle: 'bold' } },
      { content: 'Aplicación', styles: { fontStyle: 'bold' } },
      { content: 'Versión', styles: { fontStyle: 'bold' } },
      { content: 'Aplicación', styles: { fontStyle: 'bold' } },
      { content: 'Versión', styles: { fontStyle: 'bold' } }
    ]],
    body: [
      ['Adobe Reader', resolucion.adoberead || '', 'Siigo', '', 'SolidFuels', ''],
      ['Google Chrome', resolucion.goochrom || '', 'Ofima', '', '', ''],
      ['Mozilla Firefox', resolucion.mozilla || '', 'Codec K-Lite', resolucion.codecklite || '', '', ''],
      ['Adobe Acrobat', resolucion.adobeacro || '', 'VLC Media Player', '', '', ''],
      ['7Zip', resolucion.zip || '', 'FileZilla', '', '', '']
    ],
    theme: 'grid',
    styles: { 
      fontSize: 8,
      lineColor: colors.border,
      lineWidth: 1,
      textColor: [0, 0, 0]
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0]
    },
    margin: { left: 40, right: 40, top: 20, bottom: 20 }
  });

  // Observaciones
  const observacionFinal = resolucion.observaciones_gen || resolucionLog?.observacion || ticket.observacionOriginal || 'N/A';
  
  doc.autoTable({
    startY: doc.lastAutoTable.finalY,
    head: [],
    body: [
      [
        { content: 'O\nB\nS\nE\nR\nV\nA\nC\nI\nO\nN\nE\nS', styles: { fontStyle: 'bold', halign: 'center', valign: 'middle', cellWidth: 20 } },
        { content: observacionFinal, styles: { minCellHeight: 15 } }
      ]
    ],
    theme: 'grid',
    styles: { 
      fontSize: 8,
      lineColor: colors.border,
      lineWidth: 1,
      textColor: [0, 0, 0]
    },
    margin: { left: 40, right: 40, top: 20, bottom: 20 }
  });

  // Footer Firmas
  const fechaCierre = ticket.fullHistorial?.find(r => r.EstadoId === 5)?.fecha || new Date();

  doc.autoTable({
    startY: doc.lastAutoTable.finalY,
    head: [[
      { content: 'REALIZADO POR:', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'FECHA Y HORA DE CIERRE', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'RECIBIDO A SATISFACCIÓN POR:', styles: { fontStyle: 'bold', halign: 'center' } }
    ]],
    body: [
      [
        { content: ticket.nombreTecnico, styles: { halign: 'center', minCellHeight: 15, valign: 'bottom' } },
        { content: format(new Date(fechaCierre), "yyyy-MM-dd hh:mm a"), styles: { halign: 'center', valign: 'middle' } },
        { content: ticket.nombre, styles: { halign: 'center', valign: 'bottom' } }
      ]
    ],
    theme: 'grid',
    styles: { 
      fontSize: 8,
      lineColor: colors.border,
      lineWidth: 1,
      textColor: [0, 0, 0]
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0]
    },
    margin: { left: 40, right: 40, top: 20, bottom: 20 }
  });

  doc.save(`Reporte_GTI_Ticket_${ticket.TicketId || ticket.id}.pdf`);
};
